module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('article', [_c('div', {
    ref: "menu",
    staticClass: "nav-menu bg-darkBlue"
  }, [(_vm.active) ? _c('ul', {
    staticClass: "unstyled-list no-margin lv1-menu",
    style: ({
      minHeight: _vm.menuHeight + 'px'
    })
  }, _vm._l((_vm.menu), function(m) {
    return _c('li', {
      class: {
        'active': _vm.active == m
      },
      attrs: {
        "title": m.title
      },
      on: {
        "click": function($event) {
          _vm.active = m
        }
      }
    }, [_c('i', {
      class: m.icon
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "assistant",
    style: ({
      minHeight: _vm.menuHeight + 'px'
    })
  }, [_c('h3', {
    staticClass: "no-margin align-center"
  }, [_vm._v(_vm._s(_vm.active.title))]), _vm._v(" "), (_vm.activeNode) ? _c('ul', {
    staticClass: "unstyled-list no-margin lv2-menu"
  }, _vm._l((_vm.active.nodes), function(item) {
    return _c('li', {
      class: {
        'active': _vm.activeNode.name == item.name
      },
      on: {
        "click": function($event) {
          _vm.activeNode = item
        }
      }
    }, [_c('a', {
      staticClass: "text-ellipsis"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name))])])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "router-content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('footer')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "flex-grid bg-dark"
  }, [_c('div', {
    staticClass: "row flex-just-sb"
  }, [_c('div', {
    staticClass: "intro fg-white"
  }, [_vm._v("\n        VIUI"), _c('small', {
    staticStyle: {
      "font-size": "14px",
      "font-style": "italic"
    }
  }, [_vm._v("Metro UI组件库 - Vue(2.x)")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "app-menu unstyled-list clearfix"
  }, [_c('li', {
    staticClass: "fg-white"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/watson-yan/viui",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Github [Stared me!]")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea2b447"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 394
// module chunks = 1